'use client';
import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.033 18c6.037 0 9.34-4.617 9.34-8.62 0-.13-.004-.263-.01-.392A6.407 6.407 0 0 0 20 7.419a6.898 6.898 0 0 1-1.884.476 3.103 3.103 0 0 0 1.443-1.676 6.942 6.942 0 0 1-2.083.736 3.38 3.38 0 0 0-1.863-.915 3.527 3.527 0 0 0-2.081.319 3.149 3.149 0 0 0-1.443 1.42 2.82 2.82 0 0 0-.21 1.938A9.939 9.939 0 0 1 8.134 8.8a9.226 9.226 0 0 1-3.018-2.245 2.832 2.832 0 0 0-.358 2.207c.188.751.68 1.408 1.374 1.836a3.499 3.499 0 0 1-1.487-.378v.038c0 .7.261 1.378.742 1.92a3.34 3.34 0 0 0 1.891 1.05c-.482.123-.989.14-1.48.053.21.602.617 1.128 1.167 1.506a3.47 3.47 0 0 0 1.898.6 6.941 6.941 0 0 1-4.078 1.297c-.262 0-.524-.015-.784-.044A9.886 9.886 0 0 0 9.033 18Z",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgTwitter as default };
//# sourceMappingURL=twitter.svg.js.map
